import { useModalObject } from '@wecasa/common/src/hooks/use-modal';

import { translate } from '@wecasa/i18n';

import Alert from '@wecasa/web-ui/src/components/alert/alert';
import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import TextButton from '@wecasa/web-ui/src/components/button/text-button';

import TaxCreditInfoModal from './tax-credit-info-modal';

const t = translate('basket.cleaning.services.tax.alert');

const TaxCreditInfoAlert = () => {
  const { isOpen, open, close } = useModalObject();

  return (
    <>
      <TaxCreditInfoModal onClose={close} isOpen={isOpen} />
      <Alert
        type='info'
        content={
          <div>
            <Text.SM>{`${t('.text')} `}</Text.SM>
            <TextButton size='sm' onClick={open}>
              {t('.text_button')}
            </TextButton>
            <Text.SM>{' 🤩'}</Text.SM>
          </div>
        }
      />
    </>
  );
};

export default TaxCreditInfoAlert;
